<template>
</template>

<script>
export default {
  name : 'TicketWidgetTopLeftTab',

  props : ['widget'],

    watch: {
        widget() {
            this.onWidgetChange();
        }
    },

    created() {
      // console.log('#17 TicketWidgetTopLeftTab created', this.widget, this);
    },

    mounted() {
      // console.log('#21 TicketWidgetTopLeftTab mounted', this.widget, this);

      this.onWidgetChange();
    },

    methods : {
      onWidgetChange() {
        var _this = this;

        if ( !this.widget || !this.widget.type ) {
          console.log('#26 onWidgetChange', this.widget, this);
          return;
        }

        // 列表页顶部左侧 tab 隐藏显示
        if ( 'TopLeftTabPane' != this.widget.type ) {
          console.log('#37 not TopLeftTabPane', this.widget);
          return;
        }

        for (let i = 0; i < 5; i++) {
          setTimeout(() => {
            if ( !! window.showNavTabByName ) { // 等那边准备好
              window.showNavTabByName(_this.widget.parameter); // 调用方法将本来隐藏的tab展示
            }
          }, (i * 2000) + 10);
        }
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetTopLeftTab.vue